import { render, staticRenderFns } from "./update-customer-type.vue?vue&type=template&id=01e1eb04&"
import script from "./update-customer-type.vue?vue&type=script&lang=ts&"
export * from "./update-customer-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports